import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { pdfMicrositeAPIService } from '~/api/microsites/pdf';
import { PDFBuilderColors } from '~/constants/pdf';

export const updatePdfThunk = createAsyncThunk(
  'pdfSlice/updatePdfThunk',
  async (body, { getState, rejectWithValue }) => {
    try {
      const { pdfReducer } = getState();
      const response = await pdfMicrositeAPIService.updatePdfSite(body, pdfReducer.micrositeData.id);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const updatePdfFileThunk = createAsyncThunk(
  'pdfSlice/updatePdfFileThunk',
  async ({ body, id, dispatchHandler, shouldUpdate }, { rejectWithValue }) => {
    try {
      await pdfMicrositeAPIService.updatePdfFiles(body.data, body.id);

      if (dispatchHandler) {
        dispatchHandler();
      }
      if (shouldUpdate) {
        const response = await pdfMicrositeAPIService.getPdfSite(id);
        return response.data;
      }
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const pdfSlice = createSlice({
  name: 'pdfSlice',
  initialState: {
    title: '',
    selectedTemplate: 0,
    bacgkroundColor: PDFBuilderColors[0],
    fonts: {
      head: '',
      text: '',
    },
    basicInformation: {
      isFileUpload: false,
      coverImage: {},
      images: [],
    },
    pdfInformation: {
      company: '',
      title: '',
      description: '',
      website: '',
      button: 'See PDF',
    },
    stats: {
      isAutogeneratedUrl: true,
      isLimitsEnabled: false,
      url: '',
      scan: '',
    },
    loading: false,
    error: null,
    micrositeData: null,
    isCoverImageUploaded: false,
    micrositeStyles: { container: {} },
  },
  reducers: {
    setTitle(state, action) {
      state.title = action.payload;
    },
    setSelectedTemplate(state, action) {
      state.selectedTemplate = action.payload;
    },
    setBackgroundColor(state, action) {
      state.bacgkroundColor = action.payload;
    },
    setFonts(state, action) {
      state.fonts[action.payload.field] = action.payload.value;
    },
    setBasicInformation(state, action) {
      state.basicInformation[action.payload.field] = action.payload.value;
    },
    setPdfInformation(state, action) {
      state.pdfInformation[action.payload.field] = action.payload.value;
    },
    setStats(state, action) {
      state.stats[action.payload.field] = action.payload.value;
    },
    setStatsData(state, action) {
      state.stats = action.payload;
    },
    setNewCoverImage(state, action) {
      state.basicInformation.images[action.payload.index].previewLink = action.payload.url;
    },
    setPdfItemDetails(state, action) {
      state.basicInformation.images[action.payload.index][action.payload.field] = action.payload.value;
    },
    setImages(state, action) {
      state.basicInformation.images = action.payload;
    },
    setMicrositeData(state, action) {
      state.micrositeData = action.payload;
    },
    setIsCoverImageUploaded(state, action) {
      state.isCoverImageUploaded = action.payload;
    },
    setRenderedMicrositeData(state, action) {
      state.selectedTemplate = action.payload.selectedTemplate;
      state.bacgkroundColor = action.payload.bacgkroundColor;
      state.fonts = action.payload.fonts;
      state.basicInformation = action.payload.basicInformation;
      state.pdfInformation = action.payload.pdfInformation;
      state.micrositeData = action.payload.micrositeData;
      state.stats = action.payload.stats;
    },
    setMicrositeStyles(state, action) {
      state.micrositeStyles = action.payload;
    },
    resetState: () => {
      return pdfSlice.getInitialState();
    },
  },
  extraReducers: (builder) => {
    builder
      //pdf update
      .addCase(updatePdfThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updatePdfThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.micrositeData = action.payload;
      })
      .addCase(updatePdfThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updatePdfFileThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updatePdfFileThunk.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(updatePdfFileThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default pdfSlice.reducer;
